import { render, staticRenderFns } from "./CreateDiscountAdditionSaveForm.vue?vue&type=template&id=1f6c8bc9&scoped=true"
import script from "./CreateDiscountAdditionSaveForm.vue?vue&type=script&lang=js"
export * from "./CreateDiscountAdditionSaveForm.vue?vue&type=script&lang=js"
import style0 from "./CreateDiscountAdditionSaveForm.vue?vue&type=style&index=0&id=1f6c8bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c8bc9",
  null
  
)

export default component.exports